/**
 * 表单状态枚举
 */
export default Object.freeze({
    VALIDATE: 'validate', // 校验
    SAVE: 'save', // 保存
    SUBMIT: 'submit' // 提交
})